import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { to: "/",                label: "Home",          testid: "nav-home",       exact: true },
  { to: "/#services",       label: "Services",      testid: "nav-services",   hash: true },
  { to: "/calculators",     label: "Calculators",   testid: "nav-calculators" },
  { to: "/about",           label: "About",         testid: "nav-about" },
  { to: "/#contact",        label: "Contact",       testid: "nav-contact",    hash: true },
  { to: "/find-my-matter",  label: "Find my matter", testid: "nav-find" },
];

export default function SiteHeader() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const isActive = (item) =>
    item.exact ? location.pathname === item.to
    : item.hash ? false
    : location.pathname === item.to;

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-zinc-200">
      <div className="mx-auto max-w-7xl px-6 py-2 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group shrink-0" data-testid="site-logo" onClick={() => setOpen(false)}>
          <img
            src="/eh-logo-black.png"
            alt="E Holtzhausen Inc — Attorneys and Conveyancers"
            className="h-12 lg:h-14 w-auto object-contain"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8 text-sm">
          {NAV_LINKS.map((item) => (
            item.hash ? (
              <a key={item.to} href={item.to} data-testid={item.testid}
                 className="text-zinc-600 hover:text-zinc-900 transition-colors">{item.label}</a>
            ) : (
              <Link key={item.to} to={item.to} data-testid={item.testid}
                    className={`hover:text-zinc-900 transition-colors ${isActive(item) ? "text-zinc-900" : "text-zinc-600"}`}>
                {item.label}
              </Link>
            )
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-3">
          <Link to="/login" className="text-sm text-zinc-600 hover:text-zinc-900" data-testid="nav-login">Lawyer login</Link>
          <Link to="/intake"
                className="inline-flex items-center bg-zinc-900 text-white px-4 py-2 text-sm font-medium hover:bg-zinc-800 transition-colors"
                data-testid="nav-cta-intake">
            Get started →
          </Link>
        </div>

        {/* Mobile menu trigger */}
        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center h-10 w-10 text-zinc-900 hover:bg-zinc-50 transition-colors"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-trigger"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white" data-testid="mobile-menu">
          <nav className="px-6 py-4 flex flex-col">
            {NAV_LINKS.map((item) => (
              item.hash ? (
                <a key={item.to} href={item.to} data-testid={`${item.testid}-mobile`}
                   onClick={() => setOpen(false)}
                   className="py-3 text-zinc-700 hover:text-zinc-900 border-b border-zinc-100 last:border-0">
                  {item.label}
                </a>
              ) : (
                <Link key={item.to} to={item.to} data-testid={`${item.testid}-mobile`}
                      onClick={() => setOpen(false)}
                      className="py-3 text-zinc-700 hover:text-zinc-900 border-b border-zinc-100 last:border-0">
                  {item.label}
                </Link>
              )
            ))}
            <Link to="/login" onClick={() => setOpen(false)} data-testid="nav-login-mobile"
                  className="py-3 text-zinc-700 hover:text-zinc-900 border-b border-zinc-100">
              Lawyer login
            </Link>
            <Link to="/intake" onClick={() => setOpen(false)} data-testid="nav-cta-intake-mobile"
                  className="mt-4 inline-flex items-center justify-center bg-zinc-900 text-white px-4 py-3 text-sm font-medium hover:bg-zinc-800 transition-colors">
              Get started →
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
